<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="filters.owner.id" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-date-range-picker v-model="dateRange" clearable linked-panels placeholder="business.label.date" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="owner.name" title="business.label.owner" width="300"/>
        <vxe-column field="balance.balanceDate" title="business.label.date" width="150"/>
        <vxe-column field="numberOfLocations" title="business.label.numberOfLocations" width="150"/>
        <vxe-column field="numberOfContainers" title="business.label.numberOfContainers" width="150"/>
        <vxe-column field="numberOfFixedLocations" title="business.label.numberOfFixedLocations" width="150"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import moment from 'moment'
import { getOptions } from '@/utils/util'

export default {
  name: 'BalanceStatistics',
  data() {
    return {
      loading: false,
      data: [],
      owners: [],
      filters: new InventoryFactoryView(),
      dateRange: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    }).finally(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'owner.id': this.filters.owner.id,
        dateFilter: { start: this.dateRange[0], end: this.dateRange[1] }
      }
      findAll('balanceStatisticsFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.dateRange = [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')]
      this.data = []
      this.page = 1
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>